import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { Link as ScrollToLink } from "react-scroll";

interface LinkInterface {
  to: string;
  className?: string;
  target?: HTMLAnchorElement["target"];
}

/**
 * Basic link component. Will either pass to scroll to a section if a hash is supplied, or use GatsbyLink
 *
 * @param to The href for the link to navigate to
 * @param children - Children to be wrapped in a href
 * @param className - If a custom class is necessary
 * @returns a href component, will either scroll to id or gatsby navigate.
 *
 */
export const Link: React.FC<LinkInterface> = ({ to, children, className, target, ...other }) => {
  if (to && /^\/(?!\/)/.test(to)) {
    return (
      <GatsbyLink to={to} className={className} {...other} activeClassName="active" partiallyActive>
        {children}
      </GatsbyLink>
    );
  }

  if (to && to.indexOf("#") === 0) {
    return (
      <ScrollToLink className={className} to={to.replace("#", "")} spy={true} smooth={true} duration={500}>
        {children}
      </ScrollToLink>
    );
  }

  return (
    <a href={to} className={className} target={target ? target : null}>
      {children}
    </a>
  );
};
